<template>
	<div id="patient-notes-sheet" class="px-2">
		<h4 class="title is-size-5 has-text-left">Notas Anteriores</h4>
		<div class="form-new-note has-text-left my-4">
			<label for="">Agregar nueva nota</label>
			<textarea
				class="textarea mt-2"
				placeholder="Nueva nota"
				rows="2"
				v-model="newNote.message"
			></textarea>
			<button
				class="button is-bg-primary my-2"
				:class="{ 'is-loading': submittingNewNote }"
				@click="addNewNote"
			>
				Guardar
			</button>
		</div>
		<div v-if="doctorNotes.length === 0">
			<article class="message is-dark">
				<div class="message-body">Aún no hay notas del paciente</div>
			</article>
		</div>
		<div class="note-list container" v-else>
			<div class="card" v-for="(note, i) in doctorNotes" :key="'note' + i">
				<header class="card-header">
					<p class="card-header-title">
						{{ formatDateTime(note.createdAt) }}
					</p>
					<a class="card-header-icon" aria-label="more options" @click="activeNote === i ? activeNote = -1 : activeNote = i">
						<span class="icon is-txt-primary">
						<i class="fas fa-book" aria-hidden="true"></i>
						</span>
					</a>
				</header>
				<div class="card-content" v-if="activeNote === i">
					<div class="content">
						{{ note.message }}
						<br />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { DoctorNote, formatDateTime } from "@/domain/entities/EntityFields";
	import useDoctor from "@/store/DoctorState";
	import useNotification from "@/store/NotificationState";
	import usePatientHelper from "@/store/PatientHelperState";
	import { defineComponent, ref } from "vue";

	export default defineComponent({
		// props: {
		// 	doctorNotes: {
		// 		type: Array as PropType<DoctorNote[]>,
		// 		default: [],
		// 	},
		// },
		setup() {
			const { showSnackbar } = useNotification();
			const { patientSelected } = useDoctor();
			const { insertDoctorNote, listenDoctorNotes, doctorNotes } = usePatientHelper();
			listenDoctorNotes(patientSelected.value!.id)


			// add note
			const submittingNewNote = ref(false);
			const newNote = ref<DoctorNote>({
				createdAt: new Date(),
				message: "",
			});
			async function addNewNote() {
				if (newNote.value.message === "") {
					showSnackbar("No se puede ingresar una nota vacía");
					return;
				}
				submittingNewNote.value = true;
				let createdAt = new Date();
				newNote.value.createdAt = createdAt;
				try {
					await insertDoctorNote(
						newNote.value,
						patientSelected.value!.id);
					newNote.value.message = "";
					showSnackbar("Nota agregada");
				} catch (err) {
					console.error('*** error', err);
					showSnackbar("Ocurrió un error al agregar la nota");
				} finally {
					submittingNewNote.value = false;
				}
			}

			// see note
			const activeNote = ref<number>(-1);

			return {
				newNote,
				addNewNote,
				submittingNewNote,
				formatDateTime,
				activeNote,
				doctorNotes,
			};
		},
	});
</script>